package com.anjuros.website.templates.template5.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosLogo
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.components.shared.MenuIcon
import com.anjuros.website.templates.selection.styles.HeaderHeight
import com.anjuros.website.templates.selection.util.Res
import com.anjuros.website.templates.template5.components.Template5PrimaryButton
import com.anjuros.website.templates.template5.components.Template5SecondaryButton
import com.anjuros.website.templates.template5.modules.Template5HeaderItem
import com.anjuros.website.templates.template5.modules.Template5Theme
import com.anjuros.website.templates.template5.modules.getColor
import com.anjuros.website.templates.template5.modules.getColorOpacity
import com.anjuros.website.templates.template5.styles.Template5HeaderLinkStyle
import com.anjuros.website.templates.template5.util.ResKey
import com.anjuros.website.templates.template5.util.Template5CompanyDetails
import com.varabyte.kobweb.compose.css.BackdropFilter
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backdropFilter
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template5Header(modifier: Modifier) {


    Box(
        modifier = modifier
            .id("home")
            .fillMaxWidth()
            .backgroundColor(Template5Theme.Background.getColorOpacity())
            .padding(
                top =  16.px ,
             ),
        contentAlignment = Alignment.Center
    ) {

        Row(
            modifier = Modifier
                .fillMaxWidth(90.percent)
                .padding(
                    topBottom = 16.px
                ),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween
        ) {

            Row(modifier = Modifier,
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center) {
                AnjurosLogo(
                    modifier = Modifier.size(58.px)
                        .objectFit(ObjectFit.ScaleDown)
                        .zIndex(3.0),
                    src = "template5_logo.svg",
                    alt = "Logo"
                )
                P(
                    attrs = Modifier
                        .fontSize(18.px)
                        .zIndex(3.0)
                        .margin(left = 5.px)
                        .fontWeight(FontWeight.Bold)
                        .color(Template5Theme.Primary.getColor())
                        .toAttrs()
                ) {
                    AnjurosText(Template5CompanyDetails.CLIENTS_COMPANY_INFO)
                }
            }




                Row(modifier = Modifier.displayIfAtLeast(Breakpoint.LG)) {

                    Template5HeaderItem.entries.forEach {

                        Template5HeaderLink(it)

                    }

                }

                Template5SecondaryButton(
                    modifier = Modifier.displayIfAtLeast(Breakpoint.LG),
                  text = "Order Now",
                  path = Template5HeaderItem.CONTACT.path

              )

            Box(modifier = Modifier.displayUntil(Breakpoint.LG)) {
                Template5MobileMenu()
            }


        }

    }

}

@Composable
private fun Template5HeaderLink(
    item: Template5HeaderItem
) {

    Column(modifier = Template5HeaderLinkStyle.toModifier(),
        verticalArrangement = Arrangement.spacedBy(10.px),
        horizontalAlignment = Alignment.CenterHorizontally) {
        A(
            href = item.path,
            attrs = Modifier
                .margin(leftRight = 28.px)
                .fontSize(20.px)
                .zIndex(5)
                .fontWeight(FontWeight.Medium)
                .color(Template5Theme.Primary.getColor())
                .textDecorationLine(TextDecorationLine.None)
                .toAttrs()
        ) {

            Text(LocalText(item.text))

        }

            Box(
                modifier = Modifier.id("highlight")
                    .height(2.px)
                    .backgroundColor(Template5Theme.Primary.getColor())
            )

    }

}

@Composable
private fun Template5MobileMenu(
) {

    var expanded by remember {
        mutableStateOf(false)
    }

    Box(modifier = Modifier,
        contentAlignment = Alignment.TopCenter) {

        MenuIcon(
            modifier = Modifier
                .zIndex(3.0)
                .size(24.px)
                .cursor(Cursor.Pointer)
                .color(Template5Theme.Primary.rgb)
                .onClick {
                    expanded = !expanded
                }
        )

        if (expanded) {

            Column(
                modifier = HeaderHeight.toModifier()
                    .zIndex(4.0)
                    .position(Position.Absolute)
                    .top(32.px)
                    .right(10.px)
                    .width(220.px)
                    .backgroundColor(Colors.White)
                    .borderRadius(24.px)
                    .boxShadow(
                        offsetY = 8.px,
                        blurRadius = 30.px,
                        color = rgba(0, 0, 0, 0.6)
                    )
                    .border(
                        width = 1.px,
                        color = Template5Theme.Primary.rgb,
                        style = LineStyle.Solid
                    )
                    .padding(24.px)
            ) {

                Template5HeaderItem.entries.forEach {

                    Template5MobileMenuItem(
                        it
                    ) {
                        expanded = false
                    }

                }
            }

        }
        if(expanded) {
            Image(
                modifier = Modifier
                    .zIndex(4.0)
                    .cursor(Cursor.Pointer)
                    .align(Alignment.TopEnd)
                    .size(20.px)
                    .margin(top = 5.px, right = 5.px)
                    .onClick {
                        expanded = !expanded
                    }
                    ,
                src = "template5_icon_x.svg",
                alt = "Close menu"
            )
        }
    }

}

@Composable
private fun Template5MobileMenuItem(
    item: Template5HeaderItem,
    onClick: () -> Unit
) {

    A(
        href = item.path,
        attrs = Modifier
            .fillMaxWidth()
            .padding(
                topBottom = 14.px
            )
            .fontSize(17.px)
            .fontWeight(FontWeight.Medium)
            .color(Template5Theme.Primary.getColor())
            .textDecorationLine(TextDecorationLine.None)
            .cursor(Cursor.Pointer)
            .onClick {
                onClick()
            }
            .toAttrs()
    ) {
        Text(LocalText(item.text))
    }

}